export function error(message, errors, status) {
  const error = new Error(message);
  error.errors = errors;
  error.status = status;
  throw error;
}
